export default __webpack_public_path__ + "static/media/Football_field3.8480c24e.png";